<div class="confirm-dialog" [ngClass]="'tone-' + tone">
  <h2 mat-dialog-title class="dialog-title">
    <span class="title-start">
      <span class="icon" *ngIf="data?.icon">
        <i [class]="data.icon"></i>
      </span>
      <span class="text-start">{{ title }}</span>
    </span>
  </h2>

  <div mat-dialog-content class="dialog-content">
    <p class="message mb-0">{{ message }}</p>

    <div class="mt-15" *ngIf="inputEnabled">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{ inputLabel }}</mat-label>
        <input
          matInput
          [(ngModel)]="inputValue"
          [placeholder]="inputPlaceholder"
        />
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button type="button" (click)="onCancel()">
      {{ cancelText }}
    </button>
    <button
      mat-raised-button
      type="button"
      [color]="tone === 'warn' ? 'warn' : 'primary'"
      (click)="onConfirm()"
      cdkFocusInitial
    >
      {{ confirmText }}
    </button>
  </div>
</div>
